
import { useState, useEffect } from 'react';
import { ClientIntakeData } from '@/components/meal-planning/ClientIntakeForm';

// Mock client profile data - in a real app, this would come from a database or API
const mockClientProfile: Partial<ClientIntakeData> = {
  age: 35,
  gender: 'female',
  weight: 65,
  height: 165,
  activityLevel: 'moderately_active',
  dietaryPreference: 'none',
  foodExclusions: '',
  planDuration: '7'
};

export const useClientProfile = () => {
  const [profile, setProfile] = useState<Partial<ClientIntakeData> | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading client profile from database
    const loadProfile = async () => {
      setLoading(true);
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 500));
      setProfile(mockClientProfile);
      setLoading(false);
    };

    loadProfile();
  }, []);

  const updateProfile = (newProfile: Partial<ClientIntakeData>) => {
    setProfile(prev => ({ ...prev, ...newProfile }));
  };

  return {
    profile,
    loading,
    updateProfile
  };
};
